import { ElementRef, Injectable, Signal, computed, signal } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { Swiper, SwiperOptions } from 'swiper/types';

@Injectable()
export class SwiperComponentService {
  swiperContainer = signal<SwiperContainer | null>(null);

  swiper: Signal<Swiper | null> = computed(() => {
    const swiperContainer = this.swiperContainer();

    return swiperContainer ? swiperContainer.swiper : null;
  });

  constructor() {}

  /**
   * @param elNgComponentRef Ссылка на элемент компонента, в котором будет создан Swiper
   * @param initConfig
   */
  initNewSwiperInstance(elNgComponentRef: ElementRef, initConfig: SwiperOptions): Swiper {
    const swiperEl: SwiperContainer = elNgComponentRef.nativeElement.querySelector('swiper-container');

    Object.assign(swiperEl, initConfig);
    swiperEl.initialize();

    this.swiperContainer.set(swiperEl);

    return swiperEl.swiper;
  }

  updateConfig(config: SwiperOptions): void {
    const swiperEl = this.swiperContainer();
    if (swiperEl) {
      Object.assign(swiperEl, config);
    }
  }

  destroySwiperInstance(): void {
    const swiper = this.swiper();
    if (swiper) {
      swiper.destroy();
      this.swiperContainer.set(null);
    }
  }
}
